import React, { useContext } from 'react'
import './CartItems.css'
import { ShopContext } from '../../context/ShopContext'

import remove_icon from '../../Assets/cart_cross_icon.png'

const CartItems = () => {

    const {all_product,cartItems,RemoveCart,getTotalCartAmount}=useContext(ShopContext);
  return (
    <div className='cartItems'>
        <div className="cartitems-format-main">
            <p>Products</p>
            <p>Title</p>
            <p>price</p>
            <p>quantity</p>
            <p>Total</p>
            <p>Remove</p>
        </div>
        <hr />
        
        {
            all_product.map((e)=>{
                if(cartItems[e.id]>0){
                    return <div>
                    <div className="cart-item-format cartitems-format-main">
                        <img src={e.image} alt="" className='carticon-product-icon' />
                        <p>{e.name}</p>
                        <p>${e.new_price}</p>
                        <button className='cartItems-quantity'>{cartItems[e.id]}</button>
                        <p>${e.new_price*cartItems[e.id]}</p>
                        <img  className="cart-items-remove-icon" src={remove_icon} onClick={()=>{RemoveCart(e.id)}} alt="" />
        
                    </div>
                    <hr />
                </div>
                }
                return null;
            })
        }
        <div className="cartitems-down">
            <div className="cartitems-total">
                <h1>cart Totals</h1>
                <div>
                    <div className="cartitems-total-item">
                        <p>Subtotal</p>
                        <p>${getTotalCartAmount()}</p>
                    </div>
                    <hr />
                   <div className='cartitems-total-item'>
                    <p>shipping Fee
                    </p>
                    <p>free</p>
                   </div>
                   <hr />

                   <div className='cartitems-total-item'>
                    <h3>Total</h3>
                    <h3>${getTotalCartAmount()}</h3>
                   </div>

                </div>
                <button>Procced TO CheckOut</button>
            </div>
            <div className="cartitems-promocode">
                <p>if you have a promo code.enter it here</p>
                <div className="cartitems-promobox">
                    <input type="text" placeholder='promocode' />
                    <button>Submit</button>
                </div>
            </div>
        </div>


    </div>
  )
}

export default CartItems